module.exports = __webpack_public_path__ + "static/media/breakfast-brunch-desktop-1220x150.4cae3afd.jpg";